import { loadingActions } from 'modules/loading';
import { digitalizationActions } from '.';
import DigitalizationApi from './repository';

export const getContracts = () => async (dispatch) => {
  dispatch(loadingActions.show());
  dispatch(digitalizationActions.initContracts());

  return DigitalizationApi.getContracts()
    .then((contracts) => {
      dispatch(digitalizationActions.successContracts(contracts?.contracts || []));
      dispatch(loadingActions.hide());
      return contracts?.contracts || [];
    })
    .catch((error) => {
      dispatch(digitalizationActions.error(error?.data?.error || error?.message || error));
      dispatch(loadingActions.hide());
      return [];
    });
};

export const getSections = () => async (dispatch) => {
  dispatch(loadingActions.show());
  dispatch(digitalizationActions.initSections());

  return DigitalizationApi.getSections()
    .then((sections) => {
      dispatch(digitalizationActions.successSections(sections?.apartados || []));
      dispatch(loadingActions.hide());
      return sections?.apartados || [];
    })
    .catch((error) => {
      dispatch(digitalizationActions.error(error?.data?.error || error?.message || error));
      dispatch(loadingActions.hide());
      return [];
    });
};

export const getSales = () => async (dispatch) => {
  dispatch(loadingActions.show());
  dispatch(digitalizationActions.initSales());

  return DigitalizationApi.getSales()
    .then((sales) => {
      dispatch(digitalizationActions.successSales(sales?.ventas || []));
      dispatch(loadingActions.hide());
      return sales?.ventas || [];
    })
    .catch((error) => {
      dispatch(digitalizationActions.error(error?.data?.error || error?.message || error));
      dispatch(loadingActions.hide());
      return [];
    });
};

export const printDocument = (documentType, document) => async (dispatch) => {
  dispatch(loadingActions.show());
  dispatch(digitalizationActions.initDocument());

  return DigitalizationApi.printDocument(documentType, document)
    .then((response) => {
      const documents = response?.documents || [];
      const base64 = documents.length > 0 ? documents[0] : null;
      dispatch(digitalizationActions.successDocument(base64));
      dispatch(loadingActions.hide());
      return base64;
    })
    .catch((error) => {
      dispatch(digitalizationActions.error(error?.data?.error || error?.message || error));
      dispatch(loadingActions.hide());
      return null;
    });
};

export const printDocumentAsPdf = (documentType, document) => async (dispatch) => {
  dispatch(loadingActions.show());
  dispatch(digitalizationActions.initDocument());

  return DigitalizationApi.printDocumentAsPdf(documentType, document)
    .then((blob) => {
      dispatch(loadingActions.hide());
      return blob;
    })
    .catch((error) => {
      dispatch(digitalizationActions.error(error?.data?.error || error?.message || error));
      dispatch(loadingActions.hide());
      return null;
    });
};

export const printNoteAsPdf = (noteId) => async (dispatch) => {
  dispatch(loadingActions.show());

  return DigitalizationApi.printNoteAsPdf(noteId)
    .then((blob) => {
      dispatch(loadingActions.hide());
      return blob;
    })
    .catch((error) => {
      dispatch(digitalizationActions.error(error?.data?.error || error?.message || error));
      dispatch(loadingActions.hide());
      return null;
    });
};

export const printDigitalizedDocument = (path) => async (dispatch) => {
  dispatch(loadingActions.show());

  return DigitalizationApi.printDigitalizedDocument(path)
    .then((blob) => {
      dispatch(loadingActions.hide());
      return blob;
    })
    .catch((error) => {
      dispatch(digitalizationActions.error(error?.data?.error || error?.message || error));
      dispatch(loadingActions.hide());
      return null;
    });
};
